// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function CatalogPlaceholderShopPicker(props) {
  let renderItem = props.renderItem;
  let __disabledIds = props.disabledIds;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let placeholderChildComponent = React.useCallback(() => {
    let dispatch = Auth.useDispatch();
    let sections = [{
      items: shops.map(shop => ({
        TAG: "Option",
        key: shop.id,
        label: shop.name,
        value: shop,
        disabled: disabledIds.some(id => id === shop.id)
      }))
    }];
    let newrecord = {
      ...{
        style: {
          alignSelf: "center"
        }
      }
    };
    return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Select.make, {
      placeholder: I18n.t("Select a shop"),
      preset: {
        NAME: "inputField",
        VAL: {
          required: true
        }
      },
      renderItem: renderItem,
      sections: sections,
      value: {
        TAG: "Single",
        _0: activeShop
      },
      onChange: change => {
        if (change.TAG === "Single") {
          return dispatch({
            TAG: "ActiveShopSet",
            _0: change._0
          });
        }
      }
    }), newrecord));
  }, [shops, disabledIds]);
  if (shops.length !== 0) {
    if (activeShop !== undefined) {
      return props.children;
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: {
          TAG: "Pending",
          title: I18n.t("Beware !"),
          message: props.message,
          illustration: Primitive_option.some(Illustration.shopMissing)
        },
        childComponent: placeholderChildComponent
      });
    }
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
}
let make = React.memo(CatalogPlaceholderShopPicker);
export { make };
/* make Not a pure module */